let SDK;

module.exports = {
  getSDK() {
    return SDK;
  },
  setSDK(pluginSDK) {
    SDK = pluginSDK;
  }
};



// WEBPACK FOOTER //
// ./plugins/banner/SDK.js